import type { ComponentType, ReactNode } from 'react';
import { Outlet, useSearchParams } from 'react-router';
import { shouldSkipAppShell } from './editorChrome';
import './editorSessionHost.css';

export interface EditorSessionLayoutProps {
  /** Host-specific AppShell that renders an `<Outlet />` for child routes. */
  shell: ComponentType;
  children?: ReactNode;
}

/**
 * Wraps authenticated routes: uses the host AppShell unless the editor is opened
 * as a workspace iframe (`?embedded=1`) or a minimal browser tab (`?chrome=minimal`).
 * Bare mode provides a viewport-height flex host so nested editors can fill height
 * without AppShell's flex chain.
 */
export function EditorSessionLayout({ shell: Shell }: EditorSessionLayoutProps) {
  const [params] = useSearchParams();
  if (shouldSkipAppShell(params)) {
    return (
      <div className="editor-session-host editor-session-host--bare">
        <Outlet />
      </div>
    );
  }
  return <Shell />;
}
